module.exports = __webpack_public_path__ + "static/img/1_1_3_3.64fb8995.jpg";